<template>
    <div
        v-if="show"
        class="message"
    >
        <div class="message__overlay" @click="handleClickedOverlay" />
        <div class="message__container">
            <div
                class="message__header"
                :class="headerClassObj"
            >
                <h3 class="message__title">
                    {{ title }}
                </h3>
                <button
                    ref="closeButton"
                    class="message__close-wrapper"
                    @click="handleClickedClose"
                >
                    <span class="message__close" />
                </button>
            </div>
            <div class="message__body" @click="handleClickedBody">
                <p class="message__text" v-html="text" />
            </div>
        </div>
    </div>
</template>

<script>
import { MESSAGE_CLOSE_CLASS } from '@/constants/message';
import { mapState, mapMutations } from 'vuex';

export default {
    name: 'TheMessage',
    computed: {
        ...mapState('message', {
            type: state => state.type,
            title: state => state.title,
            text: state => state.text,
            closeOnOverlayClick: state => state.closeOnOverlayClick,
            show: state => state.show
        }),
        headerClassObj() {
            return {
                ['message__header_' + this.type]: true
            }
        }
    },
    watch: {
        show(value) {
            this.setGlobalControlLockStatus(value)
        }
    },
    created() {
        window.addEventListener('keydown', this.onKeydown)
    },
    beforeUnmount() {
        window.removeEventListener('keydown', this.onKeydown)
    },
    methods: {
        ...mapMutations('message', ['hide']),
        ...mapMutations('keyControl', ['setGlobalControlLockStatus']),
        handleClickedClose() {
            this.hide()
        },
        handleClickedOverlay() {
            if (this.closeOnOverlayClick) this.hide()
        },
        handleClickedBody(event) {
            if (event.target.classList.contains(MESSAGE_CLOSE_CLASS)) {
                this.hide()
            }
        },
        onKeydown(event) {
            if (event.code === 'Tab' && this.show) {
                event.preventDefault()
                this.$refs.closeButton.focus()
            }
        }
    }
};
</script>